import { Injectable } from '@angular/core';
import { EQimaButtonIconStyle } from '@qima/ngx-qima';

@Injectable({
  providedIn: 'root',
})
export class QimaButtonIconService {
  public readonly buttonIconStyle = EQimaButtonIconStyle;
}
